<template>
	<div class="page-header clearfix" :style="headerStyle">
		<div class="page-header-wrap">
			<div class="header-lf fl-l">
				<img
					src="/static/images/welcome-page/welcome-logo.png"
					alt
					class="logo"
				/>
			</div>
			<div class="header-rt fl-r">
				<ul class="nav-list clearfix">
					<li v-if="!userName" class="nav-item fl-r">
						<a :href="regiesterUrl">{{ getConstants('REGISTER') }}</a>
					</li>

					<li v-if="!userName" class="nav-item fl-r">
						<login-modal
							class="login-modal"
							v-if="loginShow"
							@hideModal="loginShow = false"
						></login-modal>
						<a :href="loginUrl">{{ getConstants('LOGIN') }}</a>
					</li>
					<li v-if="userName" class="nav-item user-name fl-r">
						<span v-html="userName"></span>
					</li>
					<li class="nav-item fl-r">
						<a href="/s/contactus">{{ getConstants('CONTACT_US') }}</a>
					</li>
					<li class="nav-item fl-r">
						<a href="/s/enterprise">{{
							getConstants('ENTERPRISE_EDITION_FOR_SHORT')
						}}</a>
					</li>
					<li class="nav-item fl-r">
						<a href="/s/team">{{ getConstants('TEAM_EDITION_FOR_SHORT') }}</a>
					</li>
					<li class="nav-item fl-r">
						<a href="/s/pricing">{{
							getConstants('INDIVIDUAL_EDITION_FOR_SHORT')
						}}</a>
					</li>
					<li class="nav-item fl-r">
						<a href="/">{{ getConstants('HOMEPAGE') }}</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
import LoginModal from './LoginModal'
export default {
	name: 'Header',
	data() {
		return {
			loginShow: false,
			modalInfo: {},
			regiesterUrl: `/d/signup?next=${encodeURIComponent(
				location.href,
			)}&signup_pricing=true#from=${encodeURIComponent(location.href)}`,
			loginUrl: `/d/login?next=${encodeURIComponent(
				location.href,
			)}&signup_pricing=true#from=${encodeURIComponent(location.href)}`,
		}
	},
	components: {
		LoginModal,
	},
	props: {
		userName: {
			type: [String, Boolean],
			default: false,
		},
		minWidth: {
			type: [Number, String],
			default: 1280,
		},
	},
	computed: {
		headerStyle() {
			return `min-width: ${this.minWidth}px;`
		},
	},
}
</script>

<style lang="less" scoped>
.page-header {
	box-sizing: border-box;
	position: fixed;
	z-index: 99;
	top: 0;
	left: 0;
	height: 60px;
	width: 100%;
	box-shadow: 0 4px 8px 0 rgba(134, 145, 153, 0.1);
	background: #fff;
	.page-header-wrap {
		width: 1200px;
		height: 60px;
		margin: 0 auto;
	}
	.header-lf {
		padding-top: 15px;
		padding-left: 5%;
		img {
			height: 30px;
		}
	}
	.header-rt {
		.nav-list {
			width: 800px;
			padding: 10px 0;
		}
		.nav-item {
			position: relative;
			line-height: 40px;
			margin-left: 36px;
			a {
				color: #303030;
			}
		}
		.nav-item.user-name {
			max-width: 200px;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
	}
}
.login-modal {
	position: absolute;
	top: 44px;
	left: -240px;
}
</style>
